import { useLazyQuery } from "@apollo/client";
import { FETCH_INSTANCE_DESCRIPTIONS as fetchInstanceDescriptions } from "../../../../graphql//query/Instance";
import { Button } from "../../../../components/ui";

export const buildInstanceDescriptionsInput = ({ ids = [], instance }) => {
  if (instance?.id) {
    return {
      id: {
        operator: "eq",
        value: instance.id,
      },
    };
  }

  const selectedIds = ids.filter(Boolean);
  const key = selectedIds.every(element => typeof element === "number")
    ? "id"
    : "name";

  return {
    [key]: {
      operator: "in",
      value: selectedIds,
    },
    // Explicit pagination avoids API defaults truncating larger selections.
    limit: selectedIds.length || 1,
    offset: 0,
  };
};

const copyTextWithExecCommand = value => {
  if (typeof document === "undefined") return false;

  let textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();
  textArea.setSelectionRange(0, value.length);

  try {
    return typeof document.execCommand === "function"
      ? document.execCommand("copy")
      : false;
  } finally {
    document.body.removeChild(textArea);
    textArea = null;
  }
};

export const copyTextToClipboard = async text => {
  const safeText = text || "";
  const clipboard =
    typeof navigator !== "undefined" ? navigator.clipboard : null;

  if (clipboard?.writeText) {
    try {
      await clipboard.writeText(safeText);
      return true;
    } catch (_error) {
      // Fall back to execCommand for browsers with clipboard API restrictions.
      return copyTextWithExecCommand(safeText);
    }
  }

  return copyTextWithExecCommand(safeText);
};

const CopyDescriptionBody = props => {
  const { closeModal, instance, ids } = props;
  const [fetchInstanceDescription, { loading }] = useLazyQuery(
    fetchInstanceDescriptions(),
  );

  const handleClick = async () => {
    const input = buildInstanceDescriptionsInput({ ids, instance });

    const result = await fetchInstanceDescription({ variables: { input } });
    const edges = result?.data?.instancesV2?.edges || [];
    const description = edges
      .map(instance => instance.description)
      .join("\n\n");

    await copyTextToClipboard(description);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        disabled={loading}
        label={loading ? "Fetching description" : "Copy description"}
        onClick={handleClick}
      />
    </div>
  );
};

export default CopyDescriptionBody;
